// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"54":"b1418f41","191":"05f91a4f","834":"a5e752be","889":"9ab2cc97"}[chunkId] + ".css";
};